//Icon Imports
import userIcon from '../assets/icons/user.svg'
import menuIcon from '../assets/icons/menu.svg'
import boldCloseIcon from '../assets/icons/bold-close.svg'
import logoutIcon from '../assets/icons/logout.svg'
import plusIcon from '../assets/icons/plus-mark.svg'
import plusIconBlack from '../assets/icons/rules-form-plus-icon-black.svg'
import plusAddPartnerIcon from '../assets/icons/plus-add-partner.svg'
import threeDotsVerticalIcon from '../assets/icons/three-dots-vertical.svg'
import clockRewindIcon from '../assets/icons/clock-rewind.svg'
import trashIcon from '../assets/icons/trash.svg'
import usersIcon from '../assets/icons/users.svg'
import minusIconBlack from '../assets/icons/rules-form-minus-icon-black.svg'
import addRewardsRule from '../assets/icons/add-rewards-rule.svg'
import editRewardsRule from '../assets/icons/edit-rewards-rule.svg'
import editRewardsRuleBlack from '../assets/icons/edit-rewards-rule-black.svg'
import closeIcon from '../assets/icons/close.svg'
import calendarRulesFormIcon from '../assets/icons/calendar-rules-form.svg'
import dropDownRulesFormIcon from '../assets/icons/rules-form-drop-down.svg'
import warningIcon from '../assets/icons/warning-icon.svg'
import deactivateRule from '../assets/icons/rules-deactivate-rule-icon.svg'
import FailureAlertIcon from '../assets/icons/failure-alert-icon.jsx'
import FailureAlertIconSimple from '../assets/icons/failure-alert-icon-simple.jsx'
import SuccessToastIcon from '../assets/icons/success-toast-icon.jsx'
import filterIcon from '../assets/icons/filter-lines.svg'
import helpBoldIcon from '../assets/icons/help-bold.svg'
import helpIcon from '../assets/icons/help.svg'
import checkboxCheckedIcon from '../assets/icons/checkbox-checked.svg'
import checkboxUncheckedIcon from '../assets/icons/checkbox-unchecked.svg'
import arrowCircleBrokenRight from '../assets/icons/arrow-circle-broken-right.svg'
import annotationAlertIcon from '../assets/icons/annotation-alert.svg'
import clipboardCheckIcon from '../assets/icons/clipboard-check.svg'

//Image Imports
import fastenTextLogo from '../assets/images/fasten-text-logo-white-yellow.png'

//Icon Exports
export const Icons = {
  menuIcon,
  boldCloseIcon,
  logoutIcon,
  userIcon,
  plusIcon,
  plusIconBlack,
  plusAddPartnerIcon,
  threeDotsVerticalIcon,
  clockRewindIcon,
  trashIcon,
  usersIcon,
  minusIconBlack,
  closeIcon,
  addRewardsRule,
  editRewardsRule,
  editRewardsRuleBlack,
  calendarRulesFormIcon,
  dropDownRulesFormIcon,
  warningIcon,
  deactivateRule,
  FailureAlertIcon,
  FailureAlertIconSimple,
  SuccessToastIcon,
  filterIcon,
  helpBoldIcon,
  helpIcon,
  checkboxCheckedIcon,
  checkboxUncheckedIcon,
  arrowCircleBrokenRight,
  annotationAlertIcon,
  clipboardCheckIcon,
}

//Image Exports
export const Images = {
  fastenTextLogo,
}
